import { jsx as _jsx } from "react/jsx-runtime";
import { ActionIcon, CopyButton as MantineCopyButton, rem } from "@mantine/core";
import { CheckCircle, ContentCopy } from "@mui/icons-material";
export const CopyButton = ({ value }) => {
    return (_jsx(MantineCopyButton, { value: value, children: ({ copied, copy }) => (_jsx(ActionIcon, { variant: "subtle", c: copied ? "var(--mantine-color-primary-6)" : "var(--mantine-color-gray-5)", onClick: (event) => {
                event.stopPropagation();
                copy();
            }, children: copied ? (_jsx(CheckCircle, { style: { width: rem(16) } })) : (_jsx(ContentCopy, { style: { width: rem(16) } })) })) }));
};
